module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  Entrega de Documentos "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.pagination.totalItems))])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'documento.novo'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                    Novo Documento\n                  ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-default btn-sm fileContainer hidden-print",
    attrs: {
      "disabled": _vm.isUploadingImport
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-import"
  }), _vm._v(" Importar\n                    "), _c('input', {
    attrs: {
      "accept": ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
      "type": "file"
    },
    on: {
      "change": _vm.importar
    }
  })])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.activeImport) ? _c('div', {
    staticClass: "wrapper content-transition"
  }, [_c('transition', {
    attrs: {
      "name": "slide2"
    }
  }, [(_vm.isUploadingImport) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Importando")]), _vm._v(" "), _c('import-progress', {
    attrs: {
      "percent": _vm.importStatus.percent
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide2"
    }
  }, [(!_vm.isUploadingImport && _vm.activeImport && !_vm.importStatus.finish) ? _c('div', {
    staticClass: "content-transition text-center"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]), _vm._v("\n                    Processando\n                  ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide2"
    }
  }, [(_vm.importStatus.finish) ? _c('div', {
    staticClass: "content-transition text-left"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Analisados")]), _vm._v(" "), _c('td', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.importStatus.historico.analisados))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cadastros")]), _vm._v(" "), _c('td', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.importStatus.historico.cadastros))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Remoções")]), _vm._v(" "), _c('td', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.importStatus.historico.remocoes))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Erros")]), _vm._v(" "), _c('td', {
    staticClass: "font-bold"
  }, [_vm._v("\n                          " + _vm._s(_vm.importStatus.historico.erros) + "\n                          "), (_vm.importStatus.historico.erros > 0) ? _c('a', {
    staticClass: "text-danger m-l-xs",
    on: {
      "click": function($event) {
        _vm.importStatus.mostrarErros = !_vm.importStatus.mostrarErros
      }
    }
  }, [_vm._v(_vm._s(_vm.importStatus.mostrarErros ? 'ocultar' : 'mostrar') + " erros")]) : _vm._e()])])])]), _vm._v(" "), (_vm.importStatus.mostrarErros) ? _c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.importStatus.historico.logErros), function(erro) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(erro))])])
  }), 0)]) : _vm._e()]) : _vm._e()])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "wrapper clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 m-b-xs"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "disabled": _vm.checkeds < 1
    },
    on: {
      "click": _vm.deleteItems
    }
  }, [_vm._v("Deletar\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.busca),
      expression: "filtros.busca"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filtros.busca)
    },
    on: {
      "keyup": _vm.pesquisar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "busca", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buscar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedAll),
      expression: "checkedAll"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedAll) ? _vm._i(_vm.checkedAll, null) > -1 : (_vm.checkedAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedAll = $$c
        }
      }, function($event) {
        return _vm.checkAll(_vm.data)
      }]
    }
  }), _c('i')])]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Código / Lote")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Documento")]), _vm._v(" "), _c('th', [_vm._v("Leilão")])])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (_vm.isLoading) ? _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.filteredData), function(doc) {
    return _c('tr', {
      attrs: {
        "title": doc.manualDescricao
      }
    }, [_c('td', {
      staticClass: "v-middle"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (doc.selected),
        expression: "doc.selected"
      }],
      attrs: {
        "type": "checkbox",
        "name": "post[]",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(doc.selected) ? _vm._i(doc.selected, null) > -1 : (doc.selected)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.lazyCheck(doc)
        },
        "change": function($event) {
          var $$a = doc.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(doc, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(doc, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(doc, "selected", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(doc.id)
        }
      }
    }, [_vm._v(_vm._s(doc.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(doc.id)
        }
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link"
    }, [_vm._v(_vm._s(doc.codigo) + " / LT " + _vm._s(doc.manualLote))])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(doc.id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(doc.manualPlaca) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(doc.id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(doc.manualNome) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(doc.id)
        }
      }
    }, [(doc.manualDocumento.length === 11) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(doc.manualDocumento)))]) : (doc.manualDocumento.length === 14) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCnpj")(doc.manualDocumento)))]) : _c('span', [_vm._v(_vm._s(doc.manualDocumento))])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.open(doc.id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(doc.manualDataLeilao && doc.manualDataLeilao.date &&
      _vm.moment(doc.manualDataLeilao.date).format('L')) + "\n                  ")])])
  }), _vm._v(" "), (!_vm.filteredData || _vm.filteredData.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Nenhum registro encontrado")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('footer', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 hidden-xs"
  }, [_vm._v("\n                  Mostrar:\n                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagination.limit),
      expression: "pagination.limit"
    }],
    staticClass: "input-sm form-control w-auto inline v-middle",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pagination, "limit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.paginationLimits), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0), _vm._v("\n                  por página\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-center"
  }, [_c('small', {
    staticClass: "text-muted inline m-t-sm m-b-sm"
  }, [_vm._v(_vm._s(_vm.pagination.atualPage) + " / " + _vm._s(_vm.pagination.totalPages) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right text-center-xs"
  }, [_c('u-pagination', {
    attrs: {
      "atual": _vm.pagination.atualPage,
      "total": _vm.pagination.totalPages
    },
    on: {
      "changePage": _vm.changePage
    }
  })], 1)])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b0e8ff4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/documentos/components/Documentos.vue
// module id = 1718
// module chunks = 18